<template>
    <div class="__l">
        <h1 class="title">Admin Users</h1>
        <input type="text" v-model="term" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Users or Accounts" @keyup.enter="handleSearch">
        <div v-if="results.data">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="50%">Name</div>
                <div class="results-head" data-width="50%">Email</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectUser(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell" data-width="50%">{{ result.profile.name }}</div>
                    <div class="results-cell" data-width="50%">{{ result.email }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="20" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'Users',
    data() {
        return {
            term: '',
            results: {},
            selectedAccount: null,
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.handleSearch()

        this.setMetaTitle('List Admin Accounts | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('admin.list'), {
                params: {
                    term: 'type:admin ' + this.term,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a user
         *
         * @param  {Object} user
         * @return {void}
         */
        handleSelectUser(user) {
            this.$router.push({name: 'users.show', params: {userId: user.id}})
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'admin.list') {
            this.loadData(1)
        }

        next()
    },
}
</script>

<style lang="less">

</style>
